import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  sendInviteDialog: false,
  filterDialog: false,
  invitesListReset: false,
  invitationLogsFilter: false,
  logsListReset: false,

};

export const manageInvitesSlice = createSlice({
  name: "manage invites",
  initialState,
  reducers: {
    setInviteDialog: (state) => {
      state.sendInviteDialog = !state.sendInviteDialog;
    },

    setFilterDialog: (state) => {
      state.filterDialog = !state.filterDialog;
    },

    setInvitesListReset: (state) => {
      state.invitesListReset = !state.invitesListReset;
    },

    setInvitationLogsFilter: (state) => {
      state.invitationLogsFilter = !state.invitationLogsFilter;
    },
    setLogsListReset: (state) => {
      state.logsListReset = !state.logsListReset;
    },
  },
});

export const manageInvitesAction = manageInvitesSlice.actions;
export const manageInvitesReducer = manageInvitesSlice.reducer;
